import { apiClient, API_PRX } from '@indipia/shared';

export interface InquiryListItem {
  inquiryId: number;
  categoryCode: string | null;
  categoryName: string | null;
  caseTitle: string;
  inquiryStatus: string | null;
  statusName: string | null;
  answered: boolean;
  createdAt: string | null;
}

export interface InquiryFile {
  fileId: number;
  fileUrl: string;
}

export interface InquiryDetail extends InquiryListItem {
  caseContent: string | null;
  caseAnswer: string | null;
  answeredDtm: string | null;
  files: InquiryFile[];
}

export interface InquiryCreatePayload {
  categoryCode: string;
  caseTitle: string;
  caseContent: string;
  /** 로그인 회원 이름 스냅샷 — support가 회원 원장을 조회하지 않고 이 값을 저장한다. */
  memberName: string;
  fileMapIds?: number[];
}

function mapListItem(raw: Record<string, unknown>): InquiryListItem {
  return {
    inquiryId:     (raw['inquiryId']     ?? raw['inquiry_id'])              as number,
    categoryCode:  ((raw['categoryCode']  ?? raw['category_code'])  ?? null) as string | null,
    categoryName:  ((raw['categoryName']  ?? raw['category_name'])  ?? null) as string | null,
    caseTitle:     (raw['caseTitle']     ?? raw['case_title'])               as string,
    inquiryStatus: ((raw['inquiryStatus'] ?? raw['inquiry_status']) ?? null) as string | null,
    statusName:    ((raw['statusName']    ?? raw['status_name'])    ?? null) as string | null,
    answered:      (raw['answered'] ?? false)                                as boolean,
    createdAt:     ((raw['createdAt']     ?? raw['created_at'])     ?? null) as string | null,
  };
}

export async function fetchInquiries(): Promise<InquiryListItem[]> {
  const res = await apiClient.get(`${API_PRX.SUPPORT}/inquiries`);
  const list = (res.data?.data ?? []) as Record<string, unknown>[];
  return list.map(mapListItem);
}

export async function fetchInquiryDetail(inquiryId: number): Promise<InquiryDetail> {
  const res = await apiClient.get(`${API_PRX.SUPPORT}/inquiries/${inquiryId}`);
  const raw = res.data?.data as Record<string, unknown>;
  const rawFiles = ((raw['files'] ?? raw['fileList'] ?? []) as Record<string, unknown>[]);
  return {
    ...mapListItem(raw),
    caseContent: (raw['caseContent'] ?? raw['case_content'] ?? null)     as string | null,
    caseAnswer:  (raw['caseAnswer']  ?? raw['case_answer']  ?? null)     as string | null,
    answeredDtm: ((raw['answeredDtm'] ?? raw['answered_dtm']) ?? null)   as string | null,
    files: rawFiles.map((f) => ({
      fileId:  (f['fileId']  ?? f['file_id'])  as number,
      fileUrl: (f['fileUrl'] ?? f['file_url']) as string,
    })),
  };
}

export async function createInquiry(payload: InquiryCreatePayload): Promise<InquiryDetail> {
  const res = await apiClient.post(`${API_PRX.SUPPORT}/inquiries`, payload);
  const raw = res.data?.data as Record<string, unknown>;
  return {
    ...mapListItem(raw),
    caseContent: (raw['caseContent'] ?? raw['case_content'] ?? null)           as string | null,
    caseAnswer:  (raw['caseAnswer']  ?? raw['case_answer']  ?? null)           as string | null,
    answeredDtm: ((raw['answeredDtm'] ?? raw['answered_dtm']) ?? null)         as string | null,
    files: [],
  };
}
